import React from 'react';
import { TypographyMuted } from '@/Components/shadcn';
import UIStrings from '@/Utils/UIStrings';
import { useAssessmentsOverviewContext } from '../Contexts/AssessmentsOverviewContext';
import EmptyAssessmentsOverview from './EmptyAssessmentOverview/EmptyAssessmentsOverview';

const EmptyRecruitmentList = (): React.JSX.Element => {
    const { search } = useAssessmentsOverviewContext();

    return (
        <>
            {search && (
                <div className="bg-card flex h-60 items-center justify-center rounded-xl">
                    <TypographyMuted>{UIStrings.NoExactMatchesFound}</TypographyMuted>
                </div>
            )}
            {!search && <EmptyAssessmentsOverview />}
        </>
    );
};

export default EmptyRecruitmentList;
